import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { CLIENTE_DIRECCION_PROFORMA } from '@pcgerente-node/pcg-comun/dist/DTOs';
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from '../ContentGuia';



const ModalAgencia: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({vm,guia,setGuia}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const handleInfo = (establecimiento: CLIENTE_DIRECCION_PROFORMA) =>{
    vm.EstablecerDireccionProforma(establecimiento,guia,setGuia)
    setShow(false)
  }

  return (
    <>
      <button className='btn btn-primary' onClick={() => handleShow()}>
        Seleccionar
      </button>

      <Modal show={show} onHide={handleClose} size={"lg"} centered>
        <Modal.Header >
          <Modal.Title>Seleccione una agencia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            
            <table className="table mb-4 contextual-table table-responsive">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Ciudad</th>
                        <th>Direccion</th>
                        <th>Descripcion</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {guia.CLIENTE_DESTINATARIO?.CLIENTE_DIRECCION_PROFORMA?.map((establecimiento,id) => 
                        <tr key={id}>
                            <td className='Capitalize'>{establecimiento.establecimiento}</td>
                            <td className='Capitalize'>{establecimiento.CIUDAD?.nombre}</td>
                            <td className='Capitalize'>{establecimiento.direccion}</td>
                            <td className='Capitalize'>{establecimiento.descripcion}</td>
                            <td>
                              <button className='modalbtn-seleccionar-formularioDestinatario' onClick={() =>handleInfo(establecimiento)}>
                                seleccionar
                              </button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-danger' onClick={() => handleClose()} >Cancelar</button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalAgencia